import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTemplatesServicesGet = {
    path: "/templates/services",
    method: RouteHttpVerb.GET
};
export { locationRestTemplatesServicesGet };
